export const INSCAN_EXTRA_TEXT = {
  nl: {
    warning: "LET OP!!",
    closing: "Sluiten",
    processing: "Bezig met verwerken...",
    printingCrateCards: "Kistkaarten worden geprint...",
    rowFullPrinting: (currentKey) =>
      `Rij ${currentKey} is vol. Kaartjes worden geprint...`,
    rowFullNoNext: (currentKey, snijgroep) =>
      `Rij ${currentKey} is vol. Er is geen volgende rij ingepland voor groep ${snijgroep}.`,
    rowAdvanced: ({ currentKey, koelcel, rij }) =>
      `Rij ${currentKey} afgehandeld. Doorgeschakeld naar koelcel ${koelcel} - rij ${rij}.`,
    printFailedNoAdvance: "Print mislukt - niet doorgeschakeld.",
    warmRowCannotAssign: ({ koelcel, rij }) =>
      `Rij ${koelcel}-${rij} is nog warm - je kunt warme rijen niet aan een machine koppelen.`,
    finishRowPrinting: (currentKey) =>
      `Rij ${currentKey} wordt afgerond. Kaartjes worden geprint...`,
    finishRowDone: ({ currentKey, koelcel, rij }) =>
      `Rij ${currentKey} afgerond. Doorgeschakeld naar koelcel ${koelcel} - rij ${rij}.`,
    finishRowFailed: "Rij afronden mislukt - niet doorgeschakeld.",
    crateAddedToRow: ({ barcode, rij }) => `${barcode} toegevoegd aan rij ${rij}.`,
    inventoryTitle: "Voorraad beheer",
    finishRowTitle: "Rij afronden?",
    nextRowTitle: "Hierna",
    cratesNow: "Kisten nu",
    holdFinishLoading: "Bezig met afronden...",
    holdFinishHolding: "Vasthouden...",
    holdFinishIdle: "3 sec vasthouden om af te ronden",
    groupActive: (group) => `Groep ${group} actief`,
    groupLabel: (group) => `Groep ${group}`,
    boxesLabel: "kisten",
    editRowPartyTitle: "Wijzig rij / partij",
    emptyRowSettingsTitle: "Lege rij instellen",
    markRowOccupied: "Bezet",
    rowOccupiedShort: "Bezet",
    emptyRowOccupancyHelp:
      "Markeer deze lege rij als bezet. De rij krijgt een kruis en is niet kiesbaar bij planning of inscannen.",
    emptyRowsOnly: "Alleen lege rijen kunnen handmatig als bezet worden gemarkeerd.",
    rowOccupancySaved: "Rijstatus opgeslagen.",
    enteredAt: "Ingevoerd op",
    rowNoteLabel: "Notities:",
    rowNotePlaceholder: "Korte notitie voor deze rij...",
    rowNoteLimit: ({ words, maxWords, chars, maxChars }) =>
      `${words}/${maxWords} woorden - ${chars}/${maxChars} tekens`,
    choosePartyFirst: "Kies eerst de partij die je wilt wijzigen:",
    selectParty: "Selecteer partij...",
    partyOption: ({ index, group, perceel, gewicht, soort, count }) =>
      `${index}. Groep ${group}: ${perceel}-${gewicht}-${soort} (${count} kisten)`,
    moveCrateCount: "Aantal kisten om te verplaatsen",
    crateNumbers: "Kistnummers",
    chooseExactCrates: (count) =>
      `Je moet precies ${count} kist${count === 1 ? "" : "en"} kiezen.`,
    chooseCrateNumbers: ({ selected, count }) =>
      `Kies kistnummers (${selected}/${count} geselecteerd)`,
    mustSelectExactCrates: (count) =>
      `Je moet precies ${count} kist${count === 1 ? "" : "en"} selecteren.`,
    allowMoveToOtherParty: "Verplaatsen naar rij met andere partij toestaan",
    selectField: (field) => `Selecteer ${field.toLowerCase()}...`,
    deleteCratesTitle: "Kisten verwijderen",
    deleteCratesHelp: "Verwijdert alleen de gekozen partij/groep uit deze rij.",
    missedScanout: "Vergeten uit te scannen",
    registerTrash: "Troep / weggegooid registreren",
    cancel: "Annuleer",
    save: "Opslaan",
    busy: "Bezig...",
    chooseCrateNumbersTitle: "Kies kistnummers",
    selectExactCrates: (count) =>
      `Selecteer precies ${count} kist${count === 1 ? "" : "en"}.`,
    close: "Sluiten",
    useSelection: "Gebruik selectie",
    choosePartyToEdit: "Kies eerst welke partij je wilt wijzigen.",
    originalRowNotFound: "Originele rij niet gevonden",
    selectValidRow: "Selecteer een geldige rij",
    rowContainsOtherParty: ({ koelcel, rij }) =>
      `Rij ${koelcel}-${rij} bevat al een andere partij`,
    editNoRights: "Geen rechten om rijen/partijen te wijzigen.",
    chooseVarietyBeforeSave: "Kies een soort voordat je deze rij opslaat.",
    selectAtLeastOneCrate: "Selecteer minimaal 1 kist.",
    newRowNotFound: "Nieuwe rij bestaat niet.",
    rowNotEnoughSpace: ({ koelcel, rij }) =>
      `Rij ${koelcel}-${rij} heeft niet genoeg vrije plek.`,
    cannotMoveCratesToRow: "Kan geen kisten verplaatsen naar deze rij!",
    noCratesForSelectedPartyOnRow:
      "Geen kisten gevonden voor de geselecteerde partij op deze rij.",
    selectedCratesMismatch:
      "Aantal gekozen kisten komt niet overeen met het aantal om te verplaatsen.",
    saveDatabaseFailed: "Opslaan in de database is mislukt.",
    deleteNoRights: "Geen rechten om kisten te verwijderen.",
    choosePartyToDelete: "Kies eerst welke partij je wilt verwijderen.",
    noCratesForParty: "Geen kisten gevonden voor deze partij.",
    rowNotFoundShort: "Rij niet gevonden.",
    trashActionLabel: "Troep / weggegooid registreren",
    missedScanoutActionLabel: "Vergeten uit te scannen",
    deletePartyLabel: ({ group, perceel, gewicht, soort }) =>
      `groep ${group || "-"} - ${perceel || "-"} ${gewicht || "-"} ${soort || "-"}`,
    deleteConfirmMessage: ({ count, partyLabel, koelcel, rij, isTrash, totalKg }) =>
      `Weet je zeker dat je ${count} kist${count === 1 ? "" : "en"} wilt verwijderen voor ${partyLabel} op rij ${koelcel}-${rij}?` +
      (isTrash
        ? ` De historie blijft staan; ${totalKg} kg wordt als weggegooid geregistreerd.`
        : " De bestaande historie blijft staan."),
    deleteSuccess: (count) => `${count} kist${count === 1 ? "" : "en"} verwijderd.`,
    deleteFailed: "Kisten verwijderen is mislukt.",
    cratesMoved: "Kisten verplaatst.",
    propertiesUpdated: "Eigenschappen bijgewerkt.",
  },

  en: {
    warning: "WARNING!!",
    closing: "Close",
    processing: "Processing...",
    printingCrateCards: "Crate cards are being printed...",
    rowFullPrinting: (currentKey) =>
      `Row ${currentKey} is full. Cards are being printed...`,
    rowFullNoNext: (currentKey, snijgroep) =>
      `Row ${currentKey} is full. There is no next row planned for group ${snijgroep}.`,
    rowAdvanced: ({ currentKey, koelcel, rij }) =>
      `Row ${currentKey} completed. Switched to cooling ${koelcel} - row ${rij}.`,
    printFailedNoAdvance: "Print failed - not switched to the next row.",
    warmRowCannotAssign: ({ koelcel, rij }) =>
      `Row ${koelcel}-${rij} is still warm - warm rows cannot be assigned to a machine.`,
    finishRowPrinting: (currentKey) =>
      `Row ${currentKey} is being finished. Cards are being printed...`,
    finishRowDone: ({ currentKey, koelcel, rij }) =>
      `Row ${currentKey} finished. Switched to cooling ${koelcel} - row ${rij}.`,
    finishRowFailed: "Finishing row failed - not switched to the next row.",
    crateAddedToRow: ({ barcode, rij }) => `${barcode} added to row ${rij}.`,
    inventoryTitle: "Inventory management",
    finishRowTitle: "Finish row?",
    nextRowTitle: "Next",
    cratesNow: "Boxes now",
    holdFinishLoading: "Finishing...",
    holdFinishHolding: "Keep holding...",
    holdFinishIdle: "Hold 3 sec to finish",
    groupActive: (group) => `Group ${group} active`,
    groupLabel: (group) => `Group ${group}`,
    boxesLabel: "boxes",
    editRowPartyTitle: "Edit row / batch",
    emptyRowSettingsTitle: "Set empty row",
    markRowOccupied: "Occupied",
    rowOccupiedShort: "Occupied",
    emptyRowOccupancyHelp:
      "Mark this empty row as occupied. The row gets a cross and cannot be selected in planning or scanning.",
    emptyRowsOnly: "Only empty rows can be manually marked as occupied.",
    rowOccupancySaved: "Row status saved.",
    enteredAt: "Entered at",
    rowNoteLabel: "Notes:",
    rowNotePlaceholder: "Short note for this row...",
    rowNoteLimit: ({ words, maxWords, chars, maxChars }) =>
      `${words}/${maxWords} words - ${chars}/${maxChars} characters`,
    choosePartyFirst: "First choose the batch you want to edit:",
    selectParty: "Select batch...",
    partyOption: ({ index, group, perceel, gewicht, soort, count }) =>
      `${index}. Group ${group}: ${perceel}-${gewicht}-${soort} (${count} boxes)`,
    moveCrateCount: "Number of boxes to move",
    crateNumbers: "Box numbers",
    chooseExactCrates: (count) =>
      `You must choose exactly ${count} box${count === 1 ? "" : "es"}.`,
    chooseCrateNumbers: ({ selected, count }) =>
      `Choose box numbers (${selected}/${count} selected)`,
    mustSelectExactCrates: (count) =>
      `You must select exactly ${count} box${count === 1 ? "" : "es"}.`,
    allowMoveToOtherParty: "Allow moving to a row with another batch",
    selectField: (field) => `Select ${field.toLowerCase()}...`,
    deleteCratesTitle: "Remove boxes",
    deleteCratesHelp: "Only removes the selected batch/group from this row.",
    missedScanout: "Forgot to scan out",
    registerTrash: "Register as waste",
    cancel: "Cancel",
    save: "Save",
    busy: "Busy...",
    chooseCrateNumbersTitle: "Choose box numbers",
    selectExactCrates: (count) =>
      `Select exactly ${count} box${count === 1 ? "" : "es"}.`,
    close: "Close",
    useSelection: "Use selection",
    choosePartyToEdit: "First choose which batch you want to edit.",
    originalRowNotFound: "Original row not found",
    selectValidRow: "Select a valid row",
    rowContainsOtherParty: ({ koelcel, rij }) =>
      `Row ${koelcel}-${rij} already contains another batch`,
    editNoRights: "You are not allowed to edit rows/batches.",
    chooseVarietyBeforeSave: "Choose a variety before saving this row.",
    selectAtLeastOneCrate: "Select at least 1 box.",
    newRowNotFound: "New row does not exist.",
    rowNotEnoughSpace: ({ koelcel, rij }) =>
      `Row ${koelcel}-${rij} does not have enough free space.`,
    cannotMoveCratesToRow: "Boxes cannot be moved to this row.",
    noCratesForSelectedPartyOnRow: "No boxes found for the selected batch on this row.",
    selectedCratesMismatch:
      "The number of selected boxes does not match the number to move.",
    saveDatabaseFailed: "Saving to the database failed.",
    deleteNoRights: "You are not allowed to remove boxes.",
    choosePartyToDelete: "First choose which batch you want to remove.",
    noCratesForParty: "No boxes found for this batch.",
    rowNotFoundShort: "Row not found.",
    trashActionLabel: "Register as waste",
    missedScanoutActionLabel: "Forgot to scan out",
    deletePartyLabel: ({ group, perceel, gewicht, soort }) =>
      `group ${group || "-"} - ${perceel || "-"} ${gewicht || "-"} ${soort || "-"}`,
    deleteConfirmMessage: ({ count, partyLabel, koelcel, rij, isTrash, totalKg }) =>
      `Are you sure you want to remove ${count} box${count === 1 ? "" : "es"} for ${partyLabel} on row ${koelcel}-${rij}?` +
      (isTrash
        ? ` History stays; ${totalKg} kg will be registered as waste.`
        : " Existing history stays."),
    deleteSuccess: (count) => `${count} box${count === 1 ? "" : "es"} removed.`,
    deleteFailed: "Removing boxes failed.",
    cratesMoved: "Boxes moved.",
    propertiesUpdated: "Properties updated.",
  },

  pl: {
    warning: "OSTRZEZENIE!!",
    closing: "Zamknij",
    processing: "Trwa przetwarzanie...",
    printingCrateCards: "Trwa drukowanie kart skrzynek...",
    rowFullPrinting: (currentKey) =>
      `Rzad ${currentKey} jest pelny. Trwa drukowanie kart...`,
    rowFullNoNext: (currentKey, snijgroep) =>
      `Rzad ${currentKey} jest pelny. Nie zaplanowano kolejnego rzedu dla grupy ${snijgroep}.`,
    rowAdvanced: ({ currentKey, koelcel, rij }) =>
      `Rzad ${currentKey} zakonczony. Przelaczono na chlodnie ${koelcel} - rzad ${rij}.`,
    printFailedNoAdvance: "Drukowanie nie powiodlo sie - nie przelaczono dalej.",
    warmRowCannotAssign: ({ koelcel, rij }) =>
      `Rzad ${koelcel}-${rij} jest jeszcze cieply - nie mozna przypisac cieplego rzedu do maszyny.`,
    finishRowPrinting: (currentKey) =>
      `Rzad ${currentKey} jest konczony. Trwa drukowanie kart...`,
    finishRowDone: ({ currentKey, koelcel, rij }) =>
      `Rzad ${currentKey} zakonczony. Przelaczono na chlodnie ${koelcel} - rzad ${rij}.`,
    finishRowFailed: "Konczenie rzedu nie powiodlo sie - nie przelaczono dalej.",
    crateAddedToRow: ({ barcode, rij }) => `${barcode} dodano do rzedu ${rij}.`,
    inventoryTitle: "Zarzadzanie zapasem",
    finishRowTitle: "Zakonczyc rzad?",
    nextRowTitle: "Nastepnie",
    cratesNow: "Skrzynie teraz",
    holdFinishLoading: "Trwa konczenie...",
    holdFinishHolding: "Przytrzymaj...",
    holdFinishIdle: "Przytrzymaj 3 sek., aby zakonczyc",
    groupActive: (group) => `Grupa ${group} aktywna`,
    groupLabel: (group) => `Grupa ${group}`,
    boxesLabel: "skrzynie",
    editRowPartyTitle: "Zmien rzad / partie",
    emptyRowSettingsTitle: "Ustaw pusty rzad",
    markRowOccupied: "Zajety",
    rowOccupiedShort: "Zajety",
    emptyRowOccupancyHelp:
      "Oznacz pusty rzad jako zajety. Rzad dostanie krzyz i nie bedzie dostepny w planowaniu ani skanowaniu.",
    emptyRowsOnly: "Tylko puste rzedy mozna recznie oznaczyc jako zajete.",
    rowOccupancySaved: "Status rzedu zapisany.",
    enteredAt: "Wprowadzono",
    rowNoteLabel: "Notatki:",
    rowNotePlaceholder: "Krotka notatka dla tego rzedu...",
    rowNoteLimit: ({ words, maxWords, chars, maxChars }) =>
      `${words}/${maxWords} slow - ${chars}/${maxChars} znakow`,
    choosePartyFirst: "Najpierw wybierz partie do zmiany:",
    selectParty: "Wybierz partie...",
    partyOption: ({ index, group, perceel, gewicht, soort, count }) =>
      `${index}. Grupa ${group}: ${perceel}-${gewicht}-${soort} (${count} skrzynie)`,
    moveCrateCount: "Liczba skrzyn do przeniesienia",
    crateNumbers: "Numery skrzyn",
    chooseExactCrates: (count) =>
      `Musisz wybrac dokladnie ${count} ${count === 1 ? "skrzynie" : "skrzyn"}.`,
    chooseCrateNumbers: ({ selected, count }) =>
      `Wybierz numery skrzyn (${selected}/${count} wybrano)`,
    mustSelectExactCrates: (count) =>
      `Musisz zaznaczyc dokladnie ${count} ${count === 1 ? "skrzynie" : "skrzyn"}.`,
    allowMoveToOtherParty: "Zezwol na przeniesienie do rzedu z inna partia",
    selectField: (field) => `Wybierz ${String(field).toLowerCase()}...`,
    deleteCratesTitle: "Usun skrzynie",
    deleteCratesHelp: "Usuwa tylko wybrana partie/grupe z tego rzedu.",
    missedScanout: "Zapomniano zeskanowac wyjscie",
    registerTrash: "Zarejestruj jako odpad",
    cancel: "Anuluj",
    save: "Zapisz",
    busy: "Przetwarzanie...",
    chooseCrateNumbersTitle: "Wybierz numery skrzyn",
    selectExactCrates: (count) =>
      `Wybierz dokladnie ${count} ${count === 1 ? "skrzynie" : "skrzyn"}.`,
    close: "Zamknij",
    useSelection: "Uzyj wyboru",
    choosePartyToEdit: "Najpierw wybierz partie, ktora chcesz zmienic.",
    originalRowNotFound: "Nie znaleziono oryginalnego rzedu",
    selectValidRow: "Wybierz prawidlowy rzad",
    rowContainsOtherParty: ({ koelcel, rij }) =>
      `Rzad ${koelcel}-${rij} zawiera juz inna partie`,
    editNoRights: "Nie masz uprawnien do zmiany rzedow/partii.",
    chooseVarietyBeforeSave: "Wybierz odmiane przed zapisaniem tego rzedu.",
    selectAtLeastOneCrate: "Wybierz co najmniej 1 skrzynie.",
    newRowNotFound: "Nowy rzad nie istnieje.",
    rowNotEnoughSpace: ({ koelcel, rij }) =>
      `Rzad ${koelcel}-${rij} nie ma wystarczajaco miejsca.`,
    cannotMoveCratesToRow: "Nie mozna przeniesc skrzyn do tego rzedu.",
    noCratesForSelectedPartyOnRow:
      "Nie znaleziono skrzyn dla wybranej partii w tym rzedzie.",
    selectedCratesMismatch:
      "Liczba wybranych skrzyn nie zgadza sie z liczba do przeniesienia.",
    saveDatabaseFailed: "Zapis do bazy danych nie powiodl sie.",
    deleteNoRights: "Nie masz uprawnien do usuwania skrzyn.",
    choosePartyToDelete: "Najpierw wybierz partie, ktora chcesz usunac.",
    noCratesForParty: "Nie znaleziono skrzyn dla tej partii.",
    rowNotFoundShort: "Nie znaleziono rzedu.",
    trashActionLabel: "Zarejestruj jako odpad",
    missedScanoutActionLabel: "Zapomniano zeskanowac wyjscie",
    deletePartyLabel: ({ group, perceel, gewicht, soort }) =>
      `grupa ${group || "-"} - ${perceel || "-"} ${gewicht || "-"} ${soort || "-"}`,
    deleteConfirmMessage: ({ count, partyLabel, koelcel, rij, isTrash, totalKg }) =>
      `Czy na pewno chcesz usunac ${count} ${count === 1 ? "skrzynie" : "skrzyn"} dla ${partyLabel} z rzedu ${koelcel}-${rij}?` +
      (isTrash
        ? ` Historia zostaje; ${totalKg} kg bedzie zarejestrowane jako odpad.`
        : " Istniejaca historia zostaje."),
    deleteSuccess: (count) =>
      `${count} ${count === 1 ? "skrzynia usunieta" : "skrzyn usunieto"}.`,
    deleteFailed: "Usuwanie skrzyn nie powiodlo sie.",
    cratesMoved: "Skrzynie przeniesione.",
    propertiesUpdated: "Wlasciwosci zaktualizowane.",
  },
};
